"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = exports.formatAddress = exports.formatPercent = void 0;
const formatPercent = (value = 0) => `${value}%`;
exports.formatPercent = formatPercent;
const formatAddress = ({ address1, address2, city, state, zip, }) => {
    let address = [address1, address2, city].filter(Boolean).join(", ");
    address += ` ${[state, zip].join(" ")}`;
    return address;
};
exports.formatAddress = formatAddress;
const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber) {
        if (phoneNumber.length === 10) {
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        }
        if (phoneNumber.match(/^\((\d{3})\)\s{0,1}(\d{3})\s{0,1}-\s{0,1}(\d{4})$/)) {
            return phoneNumber;
        }
    }
    return "";
};
exports.formatPhoneNumber = formatPhoneNumber;
